var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"racine"},[_c('div',{staticClass:"payment-container"},[_c('div',{staticClass:"header"},[_c('h4',{staticClass:"title is-5"},[_vm._v(_vm._s(_vm.$t('errorPage.title')))])]),_c('div',{staticClass:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t('errorPage.message')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }